import { combineReducers } from 'redux'

import auth from './auth'
import braintree from './braintree'
import common from './common'
import error from './error'
import formData from './formData'
import formInfo from './formInfo'
import formSettings from './formSettings'
import landingPage from './landingPage'
import payment from './payment'
import promocode from './promocode'
import stripe from './stripe'
import teams from './teams'
import voucher from './voucher'

const rootReducer = combineReducers({
  formSettings,
  formInfo,
  formData,
  auth,
  common,
  error,
  landingPage,
  payment,
  braintree,
  voucher,
  promocode,
  teams,
  stripe,
})

export default rootReducer
